import _ from "lodash";

import Stack from "components/Stack";

import TransactionCollapseLine from "pages/Deal/FinancingEvents/TransactionCollapse/TransactionCollapseLine";
import { formatMoneyField } from "pages/Deal/FinancingEvents/TransactionCollapse/utils";

import { IDebtTransaction } from "entities/Deal/sdk";

interface IDebtTransactionCollapse {
  debtTransaction: IDebtTransaction;
}

const DebtTransactionCollapse = ({
  debtTransaction,
}: IDebtTransactionCollapse) => (
  <>
    <Stack display="grid" gridTemplateColumns="1fr 2fr" gap={1}>
      <TransactionCollapseLine
        name="Loan type"
        value={debtTransaction.loan_type}
      />
      <TransactionCollapseLine
        name="Rate"
        value={
          !_.isNil(debtTransaction.rate) ? `${debtTransaction.rate}%` : "N/A"
        }
      />
      <TransactionCollapseLine name="Term" value={debtTransaction.term} />
      <TransactionCollapseLine
        name="Term type"
        value={debtTransaction.term_type}
      />
    </Stack>
    <Stack display="grid" gridTemplateColumns="1fr 1fr" gap={1}>
      <TransactionCollapseLine
        name="Extended years"
        value={debtTransaction.number_of_years_extension}
      />
      <TransactionCollapseLine
        name="Debt service coverage ratio"
        value={debtTransaction.debt_service_coverage_ratio}
      />
      <TransactionCollapseLine
        name="Other sources"
        value={debtTransaction.other_sources}
      />
      <TransactionCollapseLine
        name="Other sources amount"
        value={
          !_.isNil(debtTransaction.other_sources_amount)
            ? formatMoneyField({
                currency: debtTransaction.other_sources_amount.currency,
                amount: debtTransaction.other_sources_amount.amount,
              })
            : "N/A"
        }
      />
    </Stack>
  </>
);

export default DebtTransactionCollapse;
